import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { STORE_NAMES } from './constants';

export interface User {
  userID?: string;
  userEmail: string;
  lookerURL?: string;
  acctId?: string | undefined;
  embeddedUserId?: string | null;
  availableAdvertisers?: number[];
  personalFolderId?: string | null;
  permissionFlag: 'Y' | 'N' | string;
  isInternalUser: boolean;
}

export interface UserState extends User {
  setUser: (user: Partial<Omit<User, 'isInternalUser'>>) => void;
  clearUserData: () => void;
}

const initialState: User = {
  userID: undefined,
  userEmail: '',
  lookerURL: undefined,
  acctId: undefined,
  availableAdvertisers: undefined,
  embeddedUserId: undefined,
  personalFolderId: undefined,
  permissionFlag: 'Y',
  isInternalUser: false,
};

export const useUserStore = create<UserState>()(
  devtools(
    (set) => ({
      ...initialState,
      setUser: (user) =>
        set(
          (state) => ({
            ...state,
            ...user,
            isInternalUser: (user.userEmail ?? state.userEmail).includes('@pulsepoint.com'),
          }),
          undefined,
          'user/setUser',
        ),
      clearUserData: () =>
        set(
          (state) => ({
            ...state,
            ...initialState,
          }),
          undefined,
          'user/clearUserData',
        ),
    }),
    {
      name: STORE_NAMES.USER,
      enabled: process.env.NODE_ENV === 'development',
    },
  ),
);
